import { HUMAN_READABLE_ITERABLE_EVENTS } from 'constants/eventTypes';
import { EventTypes } from 'modules/domains';
import { getKeyByValue } from '@iterable/utils';
import noop from 'utils/noop';
import { useCustomBehavioralContext } from '../../contexts/behaviorInsights/customBehavior';
import { useCustomDemographicContext } from '../../contexts/demographicInsights/CustomDemographicContext';
import { InsightType } from '../../types';

export const useDeleteCustomInsight = (insight: string, type: InsightType | null) => {
  const { deleteCustomBehavioralEvent } = useCustomBehavioralContext();
  const { deleteDemographicContactProperty } = useCustomDemographicContext();
  const dataType = getKeyByValue(HUMAN_READABLE_ITERABLE_EVENTS, insight, EventTypes.CustomEvent);

  switch (type) {
    case InsightType.behavioral:
      return () => deleteCustomBehavioralEvent(insight, dataType);
    case InsightType.demographics:
      return () => deleteDemographicContactProperty(insight);
    default:
      return noop;
  }
};
